
import { Component, Vue } from 'nuxt-property-decorator'
import { AlButton } from '~/components/ui'
import { getExternalCompareMobileHref, getExternalCompareHomeHref } from '~/utils/external-links.utils'

@Component({
  components: {
    AlButton,
  },
})
export default class BlackFridayDealsSection extends Vue {
  get linkToPlan () {
    if (this.localePath('black-friday-mobile-plans') === this.$route.path) {
      return this.externalCompareMobileHref
    } else if (
      this.localePath('black-friday-internet-plans') === this.$route.path
    ) {
      return this.externalCompareHomeHref
    } else {
      return this.externalCompareMobileHref
    }
  }

  get externalCompareMobileHref (): string {
    return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath)
  }

  get externalCompareHomeHref (): string {
    return getExternalCompareHomeHref(this.$config.BASE_URL, this.localePath)
  }
}
